function AddClass(element, styleClass) {
    element.classList.add(styleClass);
}
function RemoveClass(element, styleClass) {
    element.classList.remove(styleClass);
}
function getShadowChildren(host, tagName, className) {
    if (host) {
        const children = Array.from(host?.shadowRoot?.children || host?.children);
        const matches = [];
        for (const child of children) {
            if (child.tagName === tagName &&
                (className ? child.classList.contains(className) : true)) {
                matches.push(child);
            }
        }
        return matches;
    }
}
/**
 * The same as classList.add but accepts array of css classes
 * @param {HTMLElement} el which will receive new css classes
 * @param {string[]} cssClasses which will be added to el
 */
function addCssClasses(el, cssClasses) {
    if (el && el.classList && cssClasses && cssClasses.length) {
        el.classList.add(...cssClasses.filter((element) => element));
    }
}

var BxfNotificationGroupTypeEnum;
(function (BxfNotificationGroupTypeEnum) {
    BxfNotificationGroupTypeEnum["WIDGET"] = "widget";
    BxfNotificationGroupTypeEnum["TOAST"] = "toast";
    BxfNotificationGroupTypeEnum["WIDGET_INLINE"] = "widget-inline";
    BxfNotificationGroupTypeEnum["WIDGET_TOAST"] = "widget-toast";
    BxfNotificationGroupTypeEnum["CUSTOM_POSITION_TOAST"] = "custom-position-toast";
})(BxfNotificationGroupTypeEnum || (BxfNotificationGroupTypeEnum = {}));

const BxfNotificationGroupConstants = {
    NOTIFICATION: 'bxf-notification',
    NOTIFICATION_GROUP: 'bxf-notification-group',
    NOTIFICATION_GROUP_CONTENT: 'bxf-notification-group__content',
    NOTIFICATION_GROUP_CONTENT_WIDGET_TOAST: 'bxf-notification-group__content--widget-toast',
    NOTIFICATION_GROUP_CONTENT_WIDGET_INLINE: 'bxf-notification-group__content--widget-inline',
    DIV: 'div',
    NOTIFICATION_STYLE: 'notification-style',
    BREAK: 'br',
    TYPE: 'type',
    IS_COMPACT: 'is-compact',
    IS_TOAST: 'is-toast',
    TOAST_TYPE: 'toast-type',
    TOAST_TIMEOUT: 'toast-timeout',
    KEEP_MOUSE_FOCUS: 'keep-mouse-focus',
    DATA_TEST_SUFFIX: 'data-test-suffix',
    TRUE: 'true',
    FLEX: 'flex',
};

export { AddClass as A, BxfNotificationGroupTypeEnum as B, RemoveClass as R, BxfNotificationGroupConstants as a, addCssClasses as b, getShadowChildren as g };
